// src/components/affiliate/CoupangSideBanner.tsx
import React from 'react';
import {
    COUPANG_DISCLOSURE,
    COUPANG_MINSAENG_BANNER,
    isCoupangEnabled,
} from '../../config/coupang';

/**
 * 사이드바용 쿠팡 민생지원 배너 (120x240).
 *
 * 사이드바 위젯과 같은 카드 모양으로 감싸 튀지 않게 두고,
 * 공정위 대가성 문구를 배너 바로 아래에 함께 노출합니다.
 */
const CoupangSideBanner: React.FC = () => {
    if (!isCoupangEnabled) return null;

    return (
        <div className="gh-cpang-side">
            <iframe
                src={COUPANG_MINSAENG_BANNER.src}
                width={COUPANG_MINSAENG_BANNER.width}
                height={COUPANG_MINSAENG_BANNER.height}
                frameBorder={0}
                scrolling="no"
                referrerPolicy="unsafe-url"
                title={COUPANG_MINSAENG_BANNER.title}
                loading="lazy"
            />
            <p className="gh-cpang-side__notice">{COUPANG_DISCLOSURE}</p>
        </div>
    );
};

export default CoupangSideBanner;
